import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, Trash2 } from "lucide-react";
import { normalizeNlPhone } from "@/lib/format";

// Generieke herhaalbare dataset (bijv. contactpersonen, bankrekeningen, vrije velden)
export default function Repeater({ items = [], onChange, fields, addLabel = "Toevoegen", emptyHint, testid }) {
  const list = items || [];
  const add = () => onChange([...list, Object.fromEntries(fields.map((f) => [f.key, ""]))]);
  const upd = (i, k, v) => onChange(list.map((it, idx) => (idx === i ? { ...it, [k]: v } : it)));
  const del = (i) => onChange(list.filter((_, idx) => idx !== i));
  return (
    <div className="space-y-3" data-testid={testid}>
      {list.length === 0 && emptyHint && <p className="text-xs text-slate-400">{emptyHint}</p>}
      {list.map((it, i) => (
        <div key={i} className="border rounded-lg p-3 pr-9 relative bg-slate-50/40">
          <div className="grid sm:grid-cols-2 gap-3">
            {fields.map((f) => (
              <div key={f.key} className={f.full ? "sm:col-span-2" : ""}>
                <Label className="text-xs text-slate-500">{f.label}</Label>
                <Input value={it[f.key] || ""} onChange={(e) => upd(i, f.key, e.target.value)} onBlur={f.normalize ? (e) => upd(i, f.key, normalizeNlPhone(e.target.value)) : undefined} placeholder={f.placeholder || ""} data-testid={`${testid}-${i}-${f.key}`} />
              </div>
            ))}
          </div>
          <button type="button" onClick={() => del(i)} className="absolute top-2 right-2 text-slate-400 hover:text-red-600" title="Verwijderen" data-testid={`${testid}-remove-${i}`}><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={add} data-testid={`${testid}-add`}><Plus className="h-4 w-4 mr-1" /> {addLabel}</Button>
    </div>
  );
}
